import Providers from './Providers';

const ProvidersPage = () => {
    return (
        <Providers />
    )
};

export default ProvidersPage;